export const storeLocatorAPIKey = "AIzaSyALcwcjzZGkpMx-hCekdfwLmlZ7KlKKIFw";
